import Button from '@material-ui/core/Button';
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import CommonModalV2, { modalWidth } from "./commonModal/v2";
import ModalExitAlert from "./modalExitAlert";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SendOrderToCSModalStyle from "../../styles/sendOrderToCSCommonModalStyle";

const SubmitButtonRef = React.createRef();

class SendOrderToCS extends React.Component {
    state = {
        NoteError: false,
        ReasonError: false,
        exitModalOpen: false,
        isChangeMade: false
    }
    componentDidMount() {
        this.props.GetSendOrderToCSReasons && this.props.GetSendOrderToCSReasons();
    }

    handleNoteTextBlur = (e) => {
        let value = e.target.value.trim();
        if (value === "") {
            this.setState({ NoteError: true })
        } else if (this.state.NoteError) {
            this.setState({ NoteError: false })
        }
    }

    handleReasonBlur = (e) => {
        if (e.target.value === -1 || e.target.value === "-1") {
            this.setState({ ReasonError: true })
        } else if (this.state.ReasonError) {
            this.setState({ ReasonError: false })
        }
    }

    UNSAFE_componentWillUnmount() {
        let { ResetSendOrderToCS } = this.props;
        this.setState({isChangeMade: false})
        ResetSendOrderToCS && ResetSendOrderToCS();
    }

    handleNoteText = (e) => {
        let { SetSendOrderToCSData } = this.props;
        if (!this.state.isChangeMade) {
            this.setState({isChangeMade: true})
        }
        SetSendOrderToCSData && SetSendOrderToCSData({ name: "sendOrderToCSNote", value: e.target.value })
    }

    componentDidUpdate(prevProps) {
        if (this.state.NoteError && this.props.sendOrderToCSNote && this.props.sendOrderToCSNote.trim()) {
            this.setState({ NoteError: false })
        }
        if (this.state.ReasonError && this.props.sendOrderToCSReason && this.props.sendOrderToCSReason !== -1 && this.props.sendOrderToCSReason !== "-1") {
            this.setState({ ReasonError: false })
        }
    }

    handleReasonChange = (e) => {
        let { SetSendOrderToCSData, sendOrderToCSReason } = this.props;
        if (!this.state.isChangeMade && e.target.value !== sendOrderToCSReason) {
            this.setState({isChangeMade: true})
        }
        SetSendOrderToCSData && SetSendOrderToCSData({ name: "sendOrderToCSReason", value: e.target.value })
    }


    onSendOrderToCSButtonClick = (e) => {
        let { sendOrderToCSReason, sendOrderToCSNote, SendOrderToCS, selectedCardData = {}, productInfo, handleRouteChange, routePath, callStarted } = this.props;
        let data = {
            "OrderId": productInfo.OrderId,
            "PatientId": selectedCardData.UserId,
            "SelectedReason": sendOrderToCSReason,
            "Note": sendOrderToCSNote.trim()
        };
        if(SubmitButtonRef && SubmitButtonRef.current){
            SubmitButtonRef.current.blur &&  SubmitButtonRef.current.blur();
        }
        SendOrderToCS && SendOrderToCS(data, handleRouteChange, routePath, callStarted);
    }

    openAlertModal = () => {
        let { closeOpenSendOrderToCS } = this.props;
        if (!this.state.isChangeMade) {
            closeOpenSendOrderToCS && closeOpenSendOrderToCS();
        } else {
            this.setState({ exitModalOpen: true });
        }
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        let { closeOpenSendOrderToCS, ResetSendOrderToCS } = this.props;
        this.setState({ exitModalOpen: false });
        ResetSendOrderToCS && ResetSendOrderToCS();
        closeOpenSendOrderToCS && closeOpenSendOrderToCS();
    }

    render() {
        let { openSendOrderToCS, classes, sendOrderToCSReasons, sendOrderToCSReason, sendOrderToCSNote, isModalAlertOpen, SetModalAlertOpen, HandleGlobalValueChange } = this.props;
        return (
            <CommonModalV2 onGlobalValueChange={HandleGlobalValueChange} id="SendOrderToCSModal" title="Send order to Support" open={openSendOrderToCS} toggleModal={this.openAlertModal} style={{ width: modalWidth.l }}>
                <div data-view="send-order-to-cs-component-wrapper" className={classes.modalBody}>
                <div className={`${classes.contentEmailWrapper} ${classes.emailTemplateMarginTop}`}>
                    <div className={classes.mainTitleText}>REASON</div>
                        <FormControl variant="outlined" className={this.state.ReasonError ? classes.templateInputError : classes.templateInput}>
                            <Select
                                labelId="customized-select-label"
                                id="sendOrderToCSReason"
                                MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                classes={{ outlined: classes.productSelectStyle }}
                                value={sendOrderToCSReason}
                                name={"sendOrderToCSReason"}
                                onChange={this.handleReasonChange}
                                onBlur={this.handleReasonBlur}
                                label={void 0}
                            >
                                <MenuItem
                                    title={"-- Choose --"}
                                    classes={{ selected: classes.menuItemSelected }}
                                    className={classes.menuItemRoot}
                                    value={-1}>
                                    -- Choose --
                            </MenuItem>
                                {sendOrderToCSReasons && sendOrderToCSReasons.map((_, index) => {
                                    return <MenuItem
                                        title={_.Description}
                                        classes={{ selected: classes.menuItemSelected }}
                                        className={classes.menuItemRoot}
                                        key={index + _.Description}
                                        value={_.Description}>
                                        {_.Description}
                                    </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.contentWrapperNoAlign}>
                        <div className={classes.orderNote}>NOTE</div>
                        <textarea
                            id="sendOrderToCSNote"
                            maxLength={4000}
                            spellCheck={true}
                            name={"sendOrderToCSNote"}
                            onBlur={this.handleNoteTextBlur}
                            value={sendOrderToCSNote}
                            onChange={this.handleNoteText}
                            className={this.state.NoteError ? classes.textAreaOrderNoteError : classes.textAreaOrderNote}
                        />
                    </div>
                    <div className={classes.modalActionWrapper}>
                        <Button
                            id="sendOrderToCSButton"
                            disabled={
                                !sendOrderToCSNote || (sendOrderToCSNote && sendOrderToCSNote.trim() === "") || sendOrderToCSReason === -1
                            }
                            ref={SubmitButtonRef}
                            onClick={this.onSendOrderToCSButtonClick}
                            variant="contained" color="primary"
                            className={classes.buttonStyle}>
                            Send Order to CS
                        </Button>
                        <Button
                            id="cancelOrderToCSButton"
                            onClick={this.openAlertModal}
                            variant="contained"
                            color="primary"
                            className={classes.cancelButtonStyle}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <ModalExitAlert type="confirmation" onConfirmation={this.onConfirmation} modalOpen={this.state.isChangeMade && this.state.exitModalOpen} closeModal={this.closeAlertModal} />
                <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
            </CommonModalV2>
        )
    }
}


export default withStyles(SendOrderToCSModalStyle)(SendOrderToCS);

